import classnames from 'classnames';
import React from 'react';

import { Icon } from '@eika/icon';
import '@eika/link-panel-style';
import { Polymorph } from '@eika/polymorph';

import { LinkCardProps } from './LinkPanelTypes';
import { Tags, PanelArrow, TextContent } from './components';
import useGenerateId from './hooks/useGenerateId';

export const LinkCard: React.FC<LinkCardProps> = ({
    url,
    title,
    textOne,
    textTwo,
    textThree,
    icon,
    cardIcon,
    tags,
    ariaLabel,
    className,
    notification,
    cardType = 'background',
    formatNotification,
    children,
    as,
    attentionColor = 'default',
    ...rest
}) => {
    const textContent = { title, textOne, textTwo, textThree };
    const hasTextContent = textOne || textTwo || textThree;
    const labelId = useGenerateId();
    return (
        <Polymorph
            as={as}
            className={classnames(
                'sgw-link-card',
                { 'align-center': !hasTextContent },
                { 'no-icon': !icon },
                { 'with-notification': typeof notification === 'number' && notification > 0 },
                { 'has-additional-content': !!children },
                `attention-color--${attentionColor}`,
                `card-type--${cardType}`,
                className,
            )}
            aria-labelledby={labelId}
        >
            <a className="sgw-link-card__link" href={url} aria-label={ariaLabel} {...rest}>
                <Tags
                    className={classnames('sgw-link-card__labels', { 'with-icon': icon }, { 'no-icon': !icon })}
                    tags={tags}
                />
                {icon && (
                    <span className="card-icon__wrapper">
                        <Icon type={icon ?? cardIcon} className="card-icon" />
                    </span>
                )}
                <TextContent id={labelId} prefixClass="sgw-link-card" {...textContent} />
                <PanelArrow
                    className="sgw-link-card__arrow-wrapper"
                    notification={notification}
                    formatter={formatNotification}
                />
            </a>
            {children && <div className="sgw-link-card__content-container">{children}</div>}
        </Polymorph>
    );
};
